<template>
	<div>
		<ListAdvancedSearch
			v-if="showadvancedsearch"
			:value="search"
			:forms="forms"
			:workflows="workflows"
			@input="updateSearch"
		/>
		<div class="row">
			<div class="col-md-8">
				<div class="input-group mb-2">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
						<button
							class="btn btn-outline-primary"
							v-on:click="toggleAdvancedSearch()"
							v-if="canViewAllForms"
						>
							{{ $t("advanced") }}
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-4">
                <MenuModalBtn additionalClasses="btn-lg mb-3 mr-2"/>
				<button class="btn btn-secondary btn-lg mb-3" @click="getFormResponses()"><b-icon icon="arrow-clockwise"></b-icon></button>
				<div class="float-right d-flex align-items-start">
					<button
						v-if="!bulkMode && $UserSession.hasPriv('FORMRESPONSE_UPLOAD')"
						class="btn btn-outline-primary btn-lg mr-2 mb-3"
						@click="$router.push('/forms/upload')"
					>
						{{ $t('upload-csv') }}
					</button>
					<a id="popover-target-download" class="btn btn-secondary btn-lg mr-2 mb-3" tabindex="0" v-if="!bulkMode">
						<b-icon icon="download"></b-icon>
					</a>
					<b-popover target="popover-target-download" triggers="focus" placement="bottom" ref="popover" v-if="!bulkMode">
						<template #title>{{ $t('download') }}</template>
						<b-button @click="downloadFormResponses('csv')" class="mr-1 mb-1">{{ $t('csv') }} ({{ $tc('n-max', 1000) }})</b-button>
						<b-button @click="downloadFormResponses('pdf')">{{ $t('pdf') }} ({{ $tc('n-max', 30) }})</b-button>
					</b-popover>
					<b-dropdown
						v-if="canBulkAction"
						:variant="bulkMode ? 'primary' : 'outline-secondary'"
						class="mb-3"
						:text="bulkMode ? `${selectedItems.length} selected` : 'Bulk Actions'"
						right
					>
						<b-dropdown-item @click="handleBulkDropdown('signoff')">
							{{ $t('sign-off') }}
							<span v-if="bulkMode && bulkAction === 'signoff' && selectedItems.length" class="text-muted small ml-1">— {{ $t('apply') }}</span>
						</b-dropdown-item>
						<b-dropdown-item @click="handleBulkDropdown('review')">
							{{ $t('review') }}
							<span v-if="bulkMode && bulkAction === 'review' && selectedItems.length" class="text-muted small ml-1">— {{ $t('apply') }}</span>
						</b-dropdown-item>
						<b-dropdown-divider v-if="bulkMode" />
						<b-dropdown-item v-if="bulkMode" @click="disableBulkMode">{{ $t('cancel') }}</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="FormResponse"
			:dataUrl="dataUrl"
			dataProperty="formresponses"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectFormResponse"
			ref="infinitescroll"
			:noResultsText="$t('no-forms-found')"
			idProperty="formresponse_id"
			:bulkMode="bulkMode"
			:selectedItems="selectedItems"
			@toggleSelectItem="toggleSelectItem"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
import ListAdvancedSearch from "src/components/Forms/ListAdvancedSearch.vue";

export default {
	components: {
		InfiniteScroll,
        MenuModalBtn,
		ListAdvancedSearch,
	},
	data() {
		return {
			search: {
				q: "",
				students: [],
				teachers: [],
                subjects: [],
				completed: "",
				reviewed: "",
				signedoff: "",
				workflows: [],
				forms: [],
				programme: null ,
				year: null ,
				group: null ,
				workbookid: null ,
				date_from: null ,
				date_to: null ,
				savedreport: null,
                formfields: [],
                formfieldvalues: [],
                formfieldvalue: null
			},
			showadvancedsearch: false,
			workflows: [],
			forms: [],
            users:[],
            formfields: [],
			bulkMode: false,
			bulkAction: null,
			selectedItems: [],
		};
	},
	mounted() {

		Promise.all([this.getForms(), this.getWorkflows()]).then(() => {
			this.setSearchDefaults();
			if(!this.search.savedreport){
				this.tryGetSavedSearch();
			}
			if('submitter' in this.$route.query || 'signer' in this.$route.query){
				if('submitter' in this.$route.query){
					this.$users.getUserById.call(this, this.$route.query['submitter']).then((user) => {
						if(user){
							this.search.students.push(user);
						}
						this.getFormResponses();
					});
				}
				if('signer' in this.$route.query){
					this.$users.getUserById.call(this, this.$route.query['signer']).then((user) => {
						if(user){
							this.search = { ...this.search, teachers: [...this.search.teachers, user] };
							this.showadvancedsearch = true;
						}
						this.getFormResponses();
					});
				}
			} else {
				this.getFormResponses();
			}
		});

	},
	methods: {
		getForms() {
			this.forms = [];
			return this.$cfetch(`${this.$settings.APIBaseURL}/forms/listall`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.results
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getWorkflows() {
			this.$cfetch(`${this.$settings.APIBaseURL}/workflows/list`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.workflows = json.results;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getWorkflowDetails() {
		},
		selectFormtype() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: "Select a form type",
				selectCallback: function (selection) {
					const isSelected = self.search.formtypes.find((formtype, i) => {
						if (formtype.value === selection.value ) {
							self.$delete(self.search.formtypes, i);
							return true;
						}
					});
					if (!isSelected) {
						self.search.formtypes.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.formtypes,
				data: this.formtypes,
				idProperty: "value",
				captionKey: "text",
				selectAllBtn: true
			});
		},
		removeFormtype(selection) {
			const self = this;
			self.search.formtypes.find((formtype, i) => {
				if (formtype.value  === selection.value) {
					self.$delete(self.search.formtypes, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		selectForm() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: "Select a form",
				selectCallback: function (selection) {
					const isSelected = self.search.forms.find((form, i) => {
						if (form.id === selection.id) {
							self.$delete(self.search.forms, i);
							return true;
						}
					});
					if (!isSelected) {
						self.search.forms.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.forms,
				data: this.forms,
				captionKey: "title",
				selectAllBtn: true
			});
		},
		removeForm(selection) {
			const self = this;
			self.search.forms.find((form, i) => {
				if (form.id === selection.id) {
					self.$delete(self.search.forms, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		toggleAdvancedSearch(){
			if(this.showadvancedsearch){
				localStorage.removeItem('cafs_forms_savedsearch');
				this.setSearchDefaults();
				this.showadvancedsearch = false;
				this.getFormResponses();
			} else {
				this.showadvancedsearch = true;
			}
		},
		updateSearch(newSearch) {
			if (newSearch) {
				this.search = newSearch;
			}
			var body = JSON.parse(JSON.stringify(this.search));
			body.q = null;
			localStorage.setItem('cafs_forms_savedsearch', JSON.stringify(body));
			this.getFormResponses();
		},
		tryGetSavedSearch(){
			var savedsearch = localStorage.getItem('cafs_forms_savedsearch');
			var data = JSON.parse(savedsearch);
			if(data){
				for(var key in data){
					this.search[key] = data[key];
				};
				if(this.canViewAllForms) {
					this.showadvancedsearch = true;
				}
			}
		},
		newSearch() {
			this.getFormResponses();
		},
		setSearchDefaults(){
			this.search = {
				q: "",
				students: [],
				teachers: [],
                subjects: [],
				completed: "",
				reviewed: "",
				signedoff: "",
				workflows: [],
				forms: [],
				programme: null ,
				year: null ,
				group: null ,
				workbookid: null ,
				date_from: null ,
				date_to: null ,
				savedreport: null,
				formfields: [],
				formfieldvalues: [],
				formfieldvalue: null
			};
			for(var key in this.search){
				if(key in this.$route.query){
					this.search[key] = this.$route.query[key];
				}
			};
		},
		getFormResponses() {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					student: this.reduceUsers(this.search.students) ,
					teacher: this.reduceUsers(this.search.teachers) ,
                    subject: this.reduceUsers(this.search.subjects),
					signedoff: this.search.signedoff ? this.search.signedoff : "",
					completed: this.search.completed ? this.search.completed : "",
					workflow: this.search.workflows.map(workflow => workflow.id),
					form: this.search.forms.map(form => form.id),
					programme: this.search.programme ? this.search.programme.Id : '' ,
					year: this.search.year ,
					group: this.search.group ,
					workbookid: this.search.workbookid ,
					date_from: this.search.date_from,
					date_to: this.search.date_to,
					savedreport: this.search.savedreport,
					formfield: this.search.formfields.length === 1 ? this.search.formfields[0].id : null,
					formfieldtype: this.search.formfields.length === 1 ? this.search.formfields[0].type : null,
					formfieldvalues: this.search.formfieldvalues.map(v => v.value),
					formfieldvalue: this.search.formfieldvalue
				};
			}
			if (this.bulkMode && this.bulkAction === 'signoff') {
				body.signedoff = 'n';
				body.has_signer = 1;
			}
			if (this.bulkMode && this.bulkAction === 'review') {
				body.reviewed = 'n';
				body.has_reviewer = 1;
			}
			this.$refs.infinitescroll.getData("replace", body);
		},
		reduceUsers(input) {
			if(input && input.length){
				return input.reduce(function(output, user){
					if(user && 'id' in user){ output.push(user.id); }
					return output;
				}, []);
			}
			return [];
		},
		downloadFormResponses(format) {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					username: this.$UserSession.getValue.call(this, "username"),
					authToken: this.$UserSession.getValue.call(this, "authToken"),
					download: JSON.stringify({
						student: this.search.students.map(student => student.id),
						teacher: this.search.teachers.map(teacher => teacher.id),
                        subject: this.search.subjects.length >0 ? this.search.subjects.map(student => student.id) : [],
						signedoff: this.search.signedoff ? this.search.signedoff : "",
						completed: this.search.completed ? this.search.completed : "",
						workflow: this.search.workflows.map(workflow => workflow.id),
						form: this.search.forms.map(form => form.id),
						programme: this.search.programme ? this.search.programme.Id : '' ,
						year: this.search.year ,
						group: this.search.group ,
						workbookid: this.search.workbookid ,
						date_from: this.search.date_from,
						date_to: this.search.date_to,
						savedreport: this.search.savedreport,
						formfield: this.search.formfields.length === 1 ? this.search.formfields[0].id : null,
						formfieldtype: this.search.formfields.length === 1 ? this.search.formfields[0].type : null,
						formfieldvalues: this.search.formfieldvalues.map(v => v.value),
						formfieldvalue: this.search.formfieldvalue,
						format: format
					})
				};

    			const url = `${this.dataUrl}?` + new URLSearchParams(body).toString();
    			//alert(url);
    			window.open(url);

    			//let routeData = this.$router.resolve({href: `${this.$settings.APIBaseURL}/forms/response/listall?`, query: body});
    			//alert(routeData.href);
				//window.open(routeData.href, '_blank');

			}
		},
		onFormFieldChange() {
			this.search.formfieldvalues = [];
			this.search.formfieldvalue = null;
			this.updateSearch();
		},
		selectFormResponse(formresponse) {
			if(formresponse.savedreport && formresponse.num_users > 1){
				var completedparam = '';
				if(this.search.completed){
					completedparam = '&completed=y';
				} else {
					completedparam  = '&completed=n';
				}
				this.$router.push(`/forms/list?savedreport=${formresponse.savedreport.savedreport_id}${completedparam}&submitter=${this.$UserSession.getValue('id')}`);
			} else {
				this.$router.push(`/forms/view/${formresponse.formresponse_id}`);
			}
		},
		enableBulkMode(action) {
			this.bulkMode = true;
			this.bulkAction = action;
			this.selectedItems = [];
			this.getFormResponses();
		},
		disableBulkMode() {
			this.bulkMode = false;
			this.bulkAction = null;
			this.selectedItems = [];
			this.getFormResponses();
		},
		handleBulkDropdown(action) {
			if (this.bulkMode && this.bulkAction === action && this.selectedItems.length > 0) {
				this.applyBulkAction();
			} else {
				this.enableBulkMode(action);
			}
		},
		toggleSelectItem(item) {
			const idx = this.selectedItems.findIndex(i => i.formresponse_id === item.formresponse_id);
			if (idx === -1) {
				this.selectedItems.push(item);
			} else {
				this.selectedItems.splice(idx, 1);
			}
		},
		applyBulkAction() {
			const ids = this.selectedItems.map(item => item.formresponse_id);
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/bulkaction`, {
				method: 'post',
				data: { ids, action: this.bulkAction }
			}).then(json => {
				if (json.status.toLowerCase() === 'success') {
					this.disableBulkMode();
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {
		dataUrl() {
			return `${this.$settings.APIBaseURL}/forms/response/list${this.$route.params.list ? this.$route.params.list : ''}`;
		},
		canViewAllForms() {
			return !this.$route.params.list && this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
		},
		canBulkAction() {
			return this.$UserSession.hasPriv.call(this, "FORM_BULK_ACTIONS");
		},
	},
};
</script>
